import * as Common from "../../commons/common"

export class BaseSheet {
  id: number
  sheet_code: string
  nendo: number = null
  report_no: number = null
  page_count: number
  width: number
  height: number
  question_image_completed: boolean
  questionImageWidth: number = 0
  questionImageHeight: number = 0
  explanation_image_completed: boolean
  explanationImageWidth: number = 0
  explanationImageHeight: number = 0
  std_deadline_at: Date
  final_deadline_at: Date
  std_deadline_text: string
  final_deadline_text: string
  report_period: string
  sheet_type: number
  
  constructor(base_sheet: any){
    this.id = base_sheet.id;
    this.sheet_code = base_sheet.sheet_code;
    this.nendo = base_sheet.nendo;
    this.report_no = base_sheet.report_no;
    this.page_count = base_sheet.page_count;
    this.width = base_sheet.correct_image_size[0];
    this.height = base_sheet.correct_image_size[1];
    this.question_image_completed = base_sheet.question_image_completed;
    this.explanation_image_completed = base_sheet.explanation_image_completed;

    if(this.question_image_completed){
      this.questionImageWidth = base_sheet.question_image_size[0];
      this.questionImageHeight = base_sheet.question_image_size[1];
    }

    if(this.explanation_image_completed){
      this.explanationImageWidth = base_sheet.explanation_image_size[0];
      this.explanationImageHeight = base_sheet.explanation_image_size[1];
    }

    this.std_deadline_at = base_sheet.std_deadline_at ? new Date(base_sheet.std_deadline_at) : null;
    this.final_deadline_at = base_sheet.final_deadline_at? new Date(base_sheet.final_deadline_at) : null;
    
    const format = "M月D日HH時mm分"
    if(this.std_deadline_at){
      this.std_deadline_text = `通常締切: ${Common.formatDate(this.std_deadline_at, format)}`
    }
    if(this.final_deadline_at){
      this.final_deadline_text = `最終締切: ${Common.formatDate(this.final_deadline_at, format)}`
    }

    this.sheet_type = base_sheet.sheet_type;
  }
}

export class BaseSheetField {
  id: number
  page: number
  idx: number
  kind: number
  part1: string
  part2: string
  part3: string
  allot: number
  answer_type: number
  rim: number[]
  x: number
  y: number
  width: number
  height: number
  field_name: string = ""
  base64_image: string = null
  base64_canvas: string = null
  is_canvas_drawed: boolean = false
  is_canvas_updated: boolean = false
  answer_texts: AnswerText[] = []
  answer_text_idx: number = 0
  answer_images: AnswerImage[] = []
  answer_image_idx: number = 0
  correct_state: number
  sheet_field_mark: SheetFieldMark = null
  choice_texts: string[] = []

  get isKaitouCompleted(): boolean {
    return this.is_canvas_drawed || (this.answer_texts.length > 0 && this.answer_texts.filter(x => !x.text).length == 0) || this.answer_images.length > 0;
  }

  constructor(x: any, idx: number){
    this.id = x.id;
    this.page = x.page;
    this.idx = idx;
    this.kind = x.kind;
    this.part1 = x.part1;
    this.part2 = x.part2;
    this.part3 = x.part3;
    this.allot = x.allot;
    this.answer_type = x.answer_type;
    this.rim = x.rim;
    this.x = x.rim[0];
    this.y = x.rim[1];
    this.width = x.rim[2];
    this.height = x.rim[3];
    this.choice_texts = x.choice_texts;

    if(this.kind == Common.SheetFieldKindEnum.FIELD){
      this.field_name = this.part1;
      this.field_name += this.part2 ? this.part2 : "";
      this.field_name += this.part3 ? this.part3 : "";
      this.sheet_field_mark = x.sheet_field_mark ? x.sheet_field_mark : null;
    }else if(this.kind = Common.SheetFieldKindEnum.STUDENT_INFO){
      this.field_name = "署名欄";
    }
    
    this.base64_canvas = x.base64_canvas;

    if(this.answer_type == Common.AnswerTypeEnum.Choice){
      // 選択肢の場合、選択内容を保持するanswer_textを生成
      if(x.answer_texts && x.answer_texts.length > 0){
        // 保存データがある場合（解答済み）
        const answer_text = x.answer_texts[0];

        const answerText = new AnswerText();
        answerText.base_sheet_field_id = answer_text.base_sheet_field_id;
        answerText.text = answer_text.text;
        answerText.idx = this.answer_text_idx++;
        answerText.font_size = answer_text.font_size;
        answerText.line_height = answer_text.line_height;
        answerText.color = answer_text.color;
        answerText.x = answer_text.x;
        answerText.y = answer_text.y;
        answerText.width = answer_text.width;
        answerText.height = answer_text.height;
        answerText.direction = answer_text.direction;
        this.answer_texts.push(answerText);
      }else{
        // 保存データがない場合（未解答）
        const answerText = new AnswerText();
        answerText.base_sheet_field_id = this.id;
        answerText.text = "";
        answerText.idx = this.answer_text_idx++;
        answerText.font_size = 32;
        answerText.line_height = 0;
        answerText.color = "#000000";
        answerText.x = 1;
        answerText.y = 1;
        answerText.width = 1;
        answerText.height = 1;
        answerText.direction = Common.DirectionEnum.Horizon;
        answerText.base64_text = Common.createBase64Text(answerText, "");
        this.answer_texts.push(answerText);
      }
    }else{
      this.answer_texts = x.answer_texts.map((answer_text: any) => {
        const answerText = new AnswerText();
        answerText.id = answer_text.id;
        answerText.base_sheet_field_id = answer_text.base_sheet_field_id;
        answerText.text = answer_text.text;
        answerText.idx = this.answer_text_idx++;
        answerText.font_size = answer_text.font_size;
        answerText.line_height = answer_text.line_height;
        answerText.color = answer_text.color;
        answerText.x = answer_text.x;
        answerText.y = answer_text.y;
        answerText.width = answer_text.width;
        answerText.height = answer_text.height;
        answerText.direction = answer_text.direction;
        return answerText;
      });
    }

    for(const answer_image of x.answer_images){

      const answerImage = new AnswerImage();
      answerImage.id = answer_image.id;
      answerImage.base_sheet_field_id = answer_image.base_sheet_field_id;
      answerImage.idx = this.answer_image_idx++;
      answerImage.x = answer_image.x;
      answerImage.y = answer_image.y;
      answerImage.width = answer_image.width;
      answerImage.height = answer_image.height;
      answerImage.base64_image = answer_image.base64_image.replace("data:image/jpeg;base64,", "")

      this.answer_images.push(answerImage);
    }
  }
}

export class ParamBaseSheetField {
  id: number
  page: number
  kind: number
  field_name: string
  rim: number[]
  correct_state: number
  answer_texts: AnswerText[] = []
  answer_images: AnswerImage[] = []

  constructor(x: BaseSheetField){
    this.id = x.id;
    this.page = x.page;
    this.kind = x.kind;
    this.field_name = x.field_name;
    this.rim = x.rim;
    this.correct_state = x.correct_state;
    this.answer_texts = x.answer_texts.map(answer_text => {
      const answerText = new AnswerText();
      answerText.id = answer_text.id;
      answerText.base_sheet_field_id = answer_text.base_sheet_field_id;
      answerText.text = answer_text.text;
      answerText.idx = answer_text.idx;
      answerText.font_size = answer_text.font_size;
      answerText.line_height = answer_text.line_height;
      answerText.color = answer_text.color;
      answerText.x = answer_text.x;
      answerText.y = answer_text.y;
      answerText.width = answer_text.width;
      answerText.height = answer_text.height;
      answerText.direction = answer_text.direction;
      return answerText;
    });
    this.answer_images = x.answer_images.map(answer_image => {
      const answerImage = new AnswerImage();
      answerImage.id = answer_image.id;
      answerImage.base_sheet_field_id = answer_image.base_sheet_field_id;
      answerImage.idx = answer_image.idx;
      answerImage.x = answer_image.x;
      answerImage.y = answer_image.y;
      answerImage.width = answer_image.width;
      answerImage.height = answer_image.height;
      return answerImage;
    });
  }
}

export interface SheetFieldMark {
  id: number
  base_sheet_field_id: number
  color: string
  x: number
  y: number
  width: number
  height: number
}

export class PageItem {
  page_no: number
  base64_image: string
  base_sheet_fields: BaseSheetField[]
  scoreing_target_sheet_fields: BaseSheetField[]
  base_width: number
  base_height: number

  constructor(page_no: number, base64_image: string, base_sheet_fields: any[], base_width: number, base_height: number){
    this.page_no = page_no;
    this.base64_image = base64_image;
    this.base_sheet_fields = base_sheet_fields.filter((x: any) => x.page == this.page_no).map((x: any, idx: number) => new BaseSheetField(x, idx));
    this.scoreing_target_sheet_fields = this.base_sheet_fields.filter(x => x.sheet_field_mark);
    this.base_width = base_width;
    this.base_height = base_height;
  }
}

export class AnswerText {
  id: number = null
  base_sheet_field_id: number = null
  idx: number = null
  text: string = null
  color: string = null
  font_size: number = null
  line_height: number = null
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  direction: number = null
  base64_text: string = null
  stamp_type: number = Common.StmapTypeEnum.Text
}

export class AnswerImage {
  id: number = null
  base_sheet_field_id: number = null
  idx: number = null
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  base64_image: string = null
  isActive: boolean = false
  stamp_type: number = Common.StmapTypeEnum.Image
}

export class Point {
  x: number
  y: number
  
  constructor(x: number, y: number){
    this.x = x;
    this.y = y;
  }
}

export class Size {
  width: number
  height: number
  
  constructor(width: number, height: number){
    this.width = width;
    this.height = height;
  }
}

export class AnswerImageDiscription {
  id: number = null
  page: number = null
  x: number = null
  y: number = null
  discription_text: string = ""
  link_url: string = ""
  is_show_popover: boolean = false

  constructor(x: any){
    if(x == null){
      return;
    }

    this.id = x.id;
    this.page = x.page;
    this.x = x.x;
    this.y = x.y;
    this.discription_text = x.discription_text;
    this.link_url = x.link_url;
  }
}

export class QuestionImageDiscription {
  id: number = null
  page: number = null
  x: number = null
  y: number = null
  discription_text: string = ""
  link_url: string = ""
  is_show_popover: boolean = false

  constructor(x: any){
    if(x == null){
      return;
    }

    this.id = x.id;
    this.page = x.page;
    this.x = x.x;
    this.y = x.y;
    this.discription_text = x.discription_text;
    this.link_url = x.link_url;
  }
}

export interface RejectionStudentSheetLog {
  school_id: number
  student_code: string
  nendo: number
  sheet_code: string
  times: number
  sheet_type: number
  base_sheet_id: number
  sheet_id: number
  reason: string
  rejected_user_id: number
  rejected_user_name: string
  created_at: Date
  updated_at: Date
}

export const DirectionEnum = Object.freeze({Horizon: 1, Vertical: 2});

export const KaitouModeEnum = Object.freeze({None: 0, Text: 1, FreeLine: 2, StraightLine: 3, Eraser: 4, Delete: 5, Marker: 6});

// 現在の工程（解答・自己採点）を表すEnum
// デジレポ解答画面の場合は常に解答固定、講座の教材は解答・自己採点が切り替わる
export const CurrentModeEnum = Object.freeze({Answer: 1, SelfScoring: 2, Preview: 3});

